import { CustomerVehicleShortInfo } from "@tm/models"

export function mapCustomerVehicleShortInfo(data: any): CustomerVehicleShortInfo {
    return {
        ...data,
        initialRegistration: data.initialRegistration ? new Date(data.initialRegistration) : undefined,
        attachedOn: data.attachedOn ? new Date(data.attachedOn) : undefined,
    }
}
